import React from "react";
import { Helmet } from "react-helmet";
import { Container, Image } from "react-bootstrap";

const ThankYou = () => {
  return (
    <>
      <Helmet>
        {/* Google Tag Manager */}
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-5C95864F');
          `}
        </script>
      </Helmet>

      <section className="sp-cnt-blk">
        <Container>
          <div className="sp-cnt-in tky text-center">
            <div className="hdg">
              <figure>
                <Image
                  src={`${process.env.PUBLIC_URL}/images/thankYou-hdg.png`}
                  fluid
                />
              </figure>
            </div>

            <div className="package-tag">Thank You for Your Enquiry!</div>

            <div className="descp">
              <p className="big">
                We've received your details successfully.
              </p>

              <p>
                Our team from The Royal Chitran will contact you shortly to
                assist with your requirements.
              </p>

              <p>
                Whether it's a celebration, group visit, or a unique cultural
                experience, we're excited to help you plan something memorable.
              </p>
            </div>

            <div className="btm-corner ls">
              <Image
                src={`${process.env.PUBLIC_URL}/images/dancing.webp`}
                fluid
              />
            </div>

            <div className="btm-corner cen">
              <Image
                src={`${process.env.PUBLIC_URL}/images/singing.webp`}
                fluid
              />
            </div>

            <div className="btm-corner rs">
              <Image
                src={`${process.env.PUBLIC_URL}/images/puppet-show-tk.webp`}
                fluid
              />
            </div>
          </div>
        </Container>

        {/* Google Tag Manager (noscript) */}
        <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-5C95864F"
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
            title="gtm"
          />
        </noscript>
      </section>
    </>
  );
};

export default ThankYou;
